import React from "react";
import { Modal, Button } from "react-bootstrap";

const CustomModal = ({
  show, // Controls the visibility of the modal
  onClose, // Callback function to close the modal
  title, // Title of the modal
  body, // Body content of the modal
  type, // Type of modal: 'success', 'error', 'info', 'warning', 'confirmation'
  onConfirm, // Optional confirmation handler (for confirmation modals)
  confirmText, // Text for the confirm button (default: 'Yes')
  cancelText, // Text for the cancel button (default: 'No')
}) => {
  // Define button styles and modal header styles based on the type
  const typeStyles = {
    success: { headerClass: "bg-success text-white", buttonVariant: "success" },
    error: { headerClass: "bg-danger text-white", buttonVariant: "danger" },
    info: { headerClass: "bg-info text-white", buttonVariant: "info" },
    warning: { headerClass: "bg-warning text-white", buttonVariant: "warning" },
    confirmation: {
      headerClass: "bg-primary text-white",
      buttonVariant: "primary",
    },
  };

  const { headerClass, buttonVariant } = typeStyles[type] || {};

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header className={headerClass} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        {type === "confirmation" ? (
          <>
            <Button variant="secondary" onClick={onClose}>
              {cancelText || "Cancel"}
            </Button>
            <Button variant={buttonVariant} onClick={onConfirm}>
              {confirmText || "Confirm"}
            </Button>
          </>
        ) : (
          <Button variant={buttonVariant || "secondary"} onClick={onClose}>
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
